import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (!this.isSupportedEnvironment()) {
      window.alert(
        '現在、このサービスはPCのWindowsまたはMacでChromeを使用する環境での動作を推奨しています。現時点で不具合が発生した場合は推奨環境でお試しください。',
      );
    }
  }

  isSupportedEnvironment() {
    const userAgent = navigator.userAgent;
    const isDesktop =
      (/Windows NT/.test(userAgent) || /Macintosh/.test(userAgent)) &&
      !/Mobile|Tablet|iPhone|iPad|Android/.test(userAgent);

    return isDesktop && this.isChrome();
  }

  isChrome() {
    // Brave はuserAgent/Client HintsをChromeに偽装するため明示的に除外する
    if (typeof navigator.brave !== 'undefined') return false;

    const brands = navigator.userAgentData?.brands;
    if (brands?.length) {
      const brandNames = brands.map((brand) => brand.brand);
      return (
        brandNames.includes('Google Chrome') && !brandNames.some((name) => ['Microsoft Edge', 'Opera'].includes(name))
      );
    }

    const userAgent = navigator.userAgent;
    return (
      /Chrome\//.test(userAgent) &&
      !/Edg\//.test(userAgent) &&
      !/OPR\//.test(userAgent) &&
      !/SamsungBrowser\//.test(userAgent)
    );
  }
}
